import { getHeaders } from '../authentication';

const initialState = {
  note: null,
  error: null,
  isFetching: false,
};

const ADD_NOTE = 'ADD_NOTE';
const ADD_NOTE_SUCCESS = 'ADD_NOTE_SUCCESS';
const ADD_NOTE_FAILURE = 'ADD_NOTE_FAILURE';
const ADD_NOTE_RESET = 'ADD_NOTE_RESET';

export const addPharmacyNoteNew = (pharmacyId, text) => ({
  types: [ADD_NOTE, ADD_NOTE_SUCCESS, ADD_NOTE_FAILURE],
  payload: {
    request: {
      url: 'notes',
      method: 'POST',
      headers: getHeaders(),
      data: { text, pharmacy_id: pharmacyId },
    },
  },
});

export const addPharmacyNoteReset = () => ({
  type: ADD_NOTE_RESET,
});

const addNoteReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_NOTE:
      return { ...state, isFetching: true };
    case ADD_NOTE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        note: action.payload.data?.data?.[0],
      };
    case ADD_NOTE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error?.response?.data?.message || action.error.message,
      };
    case ADD_NOTE_RESET:
      return { note: null, isFetching: false, error: null };
    default:
      return state;
  }
};

export default addNoteReducer;
